

























import { ColorType } from 'expangine-runtime';
import { friendlyList } from '../../../common';
import TypeEditorBase from '../TypeEditorBase';


export default TypeEditorBase<ColorType, any>().extend({
  name: 'ColorEditor',
  computed: {
    description(): string {
      return this.type.options.hasAlpha
        ? 'Red, Green, Blue, and Alpha'
        : 'Red, Green, and Blue';
    },
  },
});
